import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-vessel-select-list',
    templateUrl: './vessel-select-list.component.html',
    styleUrls: ['./vessel-select-list.component.scss'],
    standalone: false
})
export class VesselSelectListComponent implements OnInit {
    searchText: string;

    public builderName: string;
    private builderId: string;

    filteredVessels: any[];

    constructor(
        public dialogRef: MatDialogRef<VesselSelectListComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {}

    ngOnInit(): void {
        const builderInfoIndex = this.data.findIndex((d) => d.builder_id !== undefined);

        if (builderInfoIndex != -1) {
            this.builderId = this.data[builderInfoIndex].builder_id;
            this.builderName = this.data[builderInfoIndex].name;
            this.data.splice(builderInfoIndex, 1);
        }
        this.filteredVessels = this.data;
    }

    filterVessels(event) {
        const searchText = event.currentTarget.value.toLowerCase();
        this.filteredVessels = this.data.filter((vessel) =>
            vessel.name.toLowerCase().includes(searchText),
        );
    }

    rowClick = (p) => {
        this.dialogRef.close(p);
    };
}
